import { ReactNode } from "react";

const SIDE_ACTIONS_WIDTH = 164;

type UserSideActionsProps = {
  children?: ReactNode;
};

export const UserSideActions = ({ children }: UserSideActionsProps) => {
  return (
    <div
      className="flex-col-el shrink-0 self-start -ml-1 rounded-r-2xl bg-white p-2 pb-3 pl-3"
      style={{
        width: SIDE_ACTIONS_WIDTH,
      }}
    >
      <div className="flex-col-el w-full gap-3">{children}</div>
    </div>
  );
};

export const SIDE_ACTIONS_BASE_WIDTH = SIDE_ACTIONS_WIDTH;
